module.exports = __webpack_public_path__ + "img/intro-screen-bg-blue.f0f3c5c4.png";